import React from 'react'
import { FormControl } from 'react-bootstrap'
import { get } from 'lodash'
import Group from './group'

const Description = ({
    value = {},
    onChange = () => {}
}) => {
    return (
        <React.Fragment>
            <Group label='Description'>
                <FormControl as='textarea' rows='4' value={get(value, 'description', '') || ''} onChange={e => onChange({ ...value, description: e.target.value})} />
            </Group>
        </React.Fragment>
    )
}

export default Description